import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import { getFullPath } from '../lib/get-full-path';
import { PICFLOW_CONFIG } from '../picflow-config';
import { BrowserService } from './browser.service';

@Injectable({
  providedIn: 'root',
})
export class CookieBannerService {
  show$ = new BehaviorSubject(false);
  private browserService = inject(BrowserService);
  private cookieService = inject(CookieService);
  private platformId = inject(PLATFORM_ID);
  private route = inject(ActivatedRoute);
  private config = inject(PICFLOW_CONFIG);

  public hide() {
    if (this.browserService.getCookies()['accepted-cookies']) return;
    this.show$.next(false);
    this.cookieService.set('accepted-cookies', 'true', 9627576230894, '/');
  }

  public handleCookieBanner() {
    if (isPlatformServer(this.platformId)) return;
    if (this.route.snapshot.queryParams.ref) return;
    if (this.route.snapshot.queryParams.noCookieBanner) return;
    if (this.browserService.getCookies()['accepted-cookies']) return;
    if (this.route.snapshot.queryParams._storyblok) return;

    const timezoneOffset = new Date().getTimezoneOffset();
    if (timezoneOffset > 0) return; // Don't show cookie banner for users west of UTC (e.g. US)

    const path = getFullPath(this.route.snapshot);
    if (path[0] === 'a') return;
    if (path[0] === 'auth') return;
    if (path[0] === 'iframe-auth') return;
    if (path[0] === 'lp') return; // https://app.asana.com/0/0/1204548507001151/f
    if (path.includes('gallery')) return;
    if (this.config.isTenantDomain) return;
    this.show$.next(true);
  }
}
